/* eslint-disable no-debugger */
import Constants from "@usas/ui-web/utils/Constants";
import { isValidDate } from '@usas/ui-web/utils/validation';

export const localValidate = (formState) => {
  let errors = {};

  if (formState.touchpointNote.trim().length === 0) {
    errors.touchpointNote = 'Touchpoint Note is required';
  } else if (formState.touchpointNote.trim().length > 5000) {
    errors.touchpointNote = 'Touchpoint Note cannot exceed 5000 characters';
  }

  if (formState.touchpointTypeId === Constants.DEFAULT_ID) {
    errors.touchpointTypeId = 'Touchpoint Type is required';
  }

  if (formState.touchpointSubjectId === Constants.DEFAULT_ID) {
    errors.touchpointSubjectId = 'Touchpoint Subject is required';    
  }

  if (formState.touchpointContactTypeId === Constants.DEFAULT_ID) {
    errors.touchpointContactTypeId = 'Touchpoint Contact Type is required';
  } 

  // if (formState.memberId.length === 0) {
  //   errors.memberId = 'Club Staff is required';
  // } 

  if (formState.touchpointDate === Constants.BLANK_DATE_STRING) {
    errors.touchpointDate = 'Touchpoint Date is required';
  } else if (!isValidDate(formState.touchpointDate)) {
    errors.touchpointDate = 'Touchpoint Date must be a valid date';
  }

  const touchpointDate = new Date(formState.touchpointDate);
  const followUpDate = new Date(formState.followUpDate);

  if (touchpointDate > followUpDate) {
    errors.followUpDate = `Followup Date (${formState.followUpDate}) must be after the Touchpoint Date (${formState.touchpointDate})`;
  } 

  return errors;
};

const ClubTouchpointsDetailValidation = async (formState) => {
  let errors = localValidate(formState);

  return errors ? errors : {};
};

export default ClubTouchpointsDetailValidation;